import { connect } from "react-redux";
import ResetPassword from "./ResetPassword";
import { resetPasswordActionCreator } from "../../data/actions";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { resetPasswordActionCreator };

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
